import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-14ddf900"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = { class: "flex buttons" }

import { ref, watch } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeSegmentPageDialog',
  props: {
    visible: { type: Boolean },
    blocked: { type: Boolean },
    isSegmentSetted: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const visibleLocal = ref(props.visible);
watch(
  () => props.visible,
  (newValue) => {
    visibleLocal.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visibleLocal.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visibleLocal).value = $event)),
    onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close'))),
    modal: "",
    header: "Сохранение данных",
    style: { width: '30rem' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, [
        _createTextVNode("Вы точно хотите выйти из раздела \"" + _toDisplayString(_ctx.isSegmentSetted ? "Просмотр сегмента" : "Создание сегмента") + "\" без сохранения?", 1),
        _hoisted_1,
        _createTextVNode(" Все настроенные данные без сохранения будут утеряны.")
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Button), {
          type: "button",
          label: "Сохранить сегмент",
          disabled: _ctx.blocked,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('createSegment')))
        }, null, 8, ["disabled"]),
        _createVNode(_unref(Button), {
          type: "button",
          label: "Выйти",
          severity: "secondary",
          disabled: _ctx.blocked,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('exit')))
        }, null, 8, ["disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})